import React, { useState } from "react";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import jwt_decode from "jwt-decode";
import axios from "axios";
import apiConfig from "../apiConfig";

const PromoCode = () => {
  const history = useHistory();

  const token = localStorage.getItem("jwtToken");
  const decodedToken = jwt_decode(token);
  const userInfo = decodedToken;

  const [inpval, setINP] = useState({
    promotionName: "",
    promotionType: "",
    bonusAmount: "",
    bonusType: "fixed", // fixed or percentage
    bonusCategory: "",
    bannerImage: null,
    turnover: "",
    status: "Active",
    startTime: "",
    endTime: "",
  });

  const [loading, setLoading] = useState(false);

  const setdata = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setINP((preval) => ({ ...preval, [name]: files[0] }));
    } else {
      setINP((preval) => ({ ...preval, [name]: value }));
    }
  };

  const addinpdata = async (e) => {
    e.preventDefault();

    const requiredFields = [
      "promotionName",
      "promotionType",
      "bonusAmount",
      "bonusCategory",
      "startTime",
      "endTime",
    ];
    for (let field of requiredFields) {
      if (!inpval[field]) {
        alert(`Please fill ${field}`);
        return;
      }
    }

    setLoading(true);

    const formData = new FormData();
    for (let key in inpval) {
      formData.append(key, inpval[key]);
    }
    formData.append("createdBy", userInfo.user_id);

    try {
      const res = await axios.post(`${apiConfig.baseURL}/api/admin/promotion_manage`,formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.status === 200) {
        alert("Promotion Created Successfully");
        history.push("/promotion");
      }
    } catch (err) {
      console.error(err);
      alert("Failed to create promotion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-8 offset-lg-2">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Create Promotion</h4>
                <Link to="/admin-promotions">
                  <button type="button" className="btn btn-success float-right">
                    Promotion List
                  </button>
                </Link>
              </div>

              <div className="card-body">
                <div className="basic-form">
                  <form onSubmit={addinpdata}>
                    {/* Promotion Name */}
                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">Promotion Name</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          name="promotionName"
                          className="form-control"
                          value={inpval.promotionName}
                          onChange={setdata}
                        />
                      </div>
                    </div>

                    {/* Promotion Type */}
                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">Promotion Type</label>
                      <div className="col-sm-9">
                        <select
                          name="promotionType"
                          className="form-control"
                          value={inpval.promotionType}
                          onChange={setdata}
                        >
                          <option value="">Select Type</option>
                          <option value="First Signup">First Signup</option>
                          <option value="Deposit Bonus">Deposit Bonus</option>
                          <option value="Cashback">Cashback</option>
                          <option value="Referral">Referral</option>
                          <option value="Special Day Offer">Special Day Offer </option>
                          <option value="offer">Offer</option>
                        </select>
                      </div>
                    </div>

                    {/* Bonus Amount and Type */}
                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">Bonus</label>
                      <div className="col-sm-6">
                        <input
                          type="number"
                          name="bonusAmount"
                          className="form-control"
                          value={inpval.bonusAmount}
                          onChange={setdata}
                          placeholder="Enter Bonus"
                        />
                      </div>
                      <div className="col-sm-3">
                        <select
                          name="bonusType"
                          className="form-control"
                          value={inpval.bonusType}
                          onChange={setdata}
                        >
                          <option value="fixed">Fixed Amount</option>
                          <option value="percentage">Percentage</option>
                        </select>
                      </div>
                    </div>

                    {/* Bonus Category */}
                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">Bonus Category</label>
                      <div className="col-sm-9">
                        <select
                          name="bonusCategory"
                          className="form-control"
                          value={inpval.bonusCategory}
                          onChange={setdata}
                        >
                          <option value="">Select Category</option>
                          <option value="One Time">One Time</option>
                          <option value="All Time">All Time</option>
                          <option value="Daily">Daily</option>
                          <option value="Weekly">Weekly</option>
                          <option value="Monthly">Monthly</option>
                          <option value="Yearly">Yearly</option>
                        </select>
                      </div>
                    </div>

                    {/* Banner Image */}
                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">Banner Image</label>
                      <div className="col-sm-9">
                        <input
                          type="file"
                          name="bannerImage"
                          className="form-control"
                          accept="image/*"
                          onChange={setdata}
                        />
                      </div>
                    </div>

                    {/* Turnover */}
                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">Turnover</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          name="turnover"
                          className="form-control"
                          value={inpval.turnover}
                          onChange={setdata}
                        />
                      </div>
                    </div>

                    {/* Start & End Time */}
                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">Start Time</label>
                      <div className="col-sm-9">
                        <input
                          type="datetime-local"
                          name="startTime"
                          className="form-control"
                          value={inpval.startTime}
                          onChange={setdata}
                        />
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">End Time</label>
                      <div className="col-sm-9">
                        <input
                          type="datetime-local"
                          name="endTime"
                          className="form-control"
                          value={inpval.endTime}
                          onChange={setdata}
                        />
                      </div>
                    </div>

                    {/* Submit */}
                    <div className="mb-3 row" align="right">
                      <div className="col-sm-10">
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                          {loading ? "Creating..." : "Create Promotion"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PromoCode;
